import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
// Both patterns share the core \{\{[^}]+\}\} — they MUST stay in sync if either changes.
export const makeVariablePattern = ()=>/\{\{([^}]+)\}\}/g;
export const VARIABLE_PRESENCE_PATTERN = /\{\{[^}]+\}\}/;
const MAX_VARIABLE_LABEL_LENGTH = 200;
const MAX_VARIABLE_DEFAULT_VALUE_LENGTH = 1000;
const HTML_TAG_PATTERN = /<\/?[a-zA-Z]/;
export function validateTemplateVariableLabel(label) {
    const trimmed = label.trim();
    if (trimmed.length === 0) return null;
    if (trimmed.length > MAX_VARIABLE_LABEL_LENGTH) return 'Label exceeds maximum length';
    if (HTML_TAG_PATTERN.test(trimmed)) return 'Label contains invalid characters';
    return null;
}
export function validateTemplateVariableDefaultValue(value) {
    if (value.length > MAX_VARIABLE_DEFAULT_VALUE_LENGTH) return 'Default value exceeds maximum length';
    if (HTML_TAG_PATTERN.test(value)) return 'Default value contains invalid characters';
    return null;
}
export const SYSTEM_VARIABLE_CATALOG = [
    {
        category: 'This notification',
        label: 'Invoice Number',
        key: 'Invoice Number'
    },
    {
        category: 'This notification',
        label: 'Refund Amount',
        key: 'Refund Amount'
    },
    {
        category: 'This notification',
        label: 'Payment Method Type',
        key: 'Payment Method Type'
    },
    {
        category: 'This notification',
        label: 'Payment Last 4',
        key: 'Payment Last 4'
    },
    {
        category: 'This notification',
        label: 'Payout Amount',
        key: 'Payout Amount'
    },
    {
        category: 'This notification',
        label: 'Payout Date',
        key: 'Payout Date'
    },
    {
        category: 'This notification',
        label: 'Failure Reason',
        key: 'Failure Reason'
    },
    {
        category: 'This notification',
        label: 'Account Last 4',
        key: 'Account Last 4'
    },
    {
        category: 'This notification',
        label: 'Auto Approval Date',
        key: 'Auto Approval Date'
    },
    {
        category: 'This notification',
        label: 'Account Identifier',
        key: 'Account Identifier'
    },
    {
        category: 'This notification',
        label: 'Year',
        key: 'Year'
    },
    {
        category: 'This notification',
        label: 'Verification Code',
        key: 'Verification Code'
    },
    {
        category: 'This notification',
        label: 'Inviting User Full Name',
        key: 'Inviting User Full Name'
    },
    {
        category: 'This notification',
        label: 'Inviting User Email',
        key: 'Inviting User Email'
    },
    {
        category: 'This notification',
        label: 'Mailbox Name',
        key: 'Mailbox Name'
    },
    {
        category: 'This notification',
        label: 'Price Increase Date',
        key: 'Price Increase Date'
    },
    {
        category: 'This notification',
        label: 'Team Member Full Name',
        key: 'Team Member Full Name'
    },
    {
        category: 'This notification',
        label: 'Custom Subject',
        key: 'Custom Subject'
    },
    {
        category: 'This notification',
        label: 'Custom Message',
        key: 'Custom Message'
    },
    {
        category: 'This notification',
        label: 'Sender First Name',
        key: 'Sender First Name'
    },
    {
        category: 'Primary contact',
        label: 'Recipient First Name',
        key: 'Recipient First Name'
    },
    {
        category: 'Primary contact',
        label: 'Recipient Last Name',
        key: 'Recipient Last Name'
    },
    {
        category: 'Client',
        label: 'Company name'
    },
    {
        category: 'Client',
        subcategory: 'Primary contact',
        label: 'Full name'
    },
    {
        category: 'Client',
        subcategory: 'Primary contact',
        label: 'First name'
    },
    {
        category: 'Client',
        subcategory: 'Primary contact',
        label: 'Last name'
    },
    {
        category: 'Client',
        subcategory: 'Primary contact',
        label: 'Email'
    },
    {
        category: 'My Business',
        label: 'Business name'
    },
    {
        category: 'Agreement',
        label: 'Agreement name'
    },
    {
        category: 'Agreement',
        label: 'Effective date'
    },
    {
        category: 'Agreement',
        label: "Today's date"
    },
    {
        category: 'Agreement',
        label: 'Current month'
    },
    {
        category: 'Agreement',
        label: 'Current year'
    }
];
// Notification-scope catalog entries are picker-only — they have no resolution logic
// and must not collide with Agreement Studio's business-default merging or category lookup.
const RESOLVABLE_SYSTEM_VARIABLES = SYSTEM_VARIABLE_CATALOG.filter((entry)=>!('key' in entry));
const normalizedSystemLabels = new Set(RESOLVABLE_SYSTEM_VARIABLES.map((entry)=>entry.label.toLowerCase()));
export function normalizeVariableLabel(label) {
    return label.toLowerCase();
}
export function isSystemVariable(label) {
    return normalizedSystemLabels.has(normalizeVariableLabel(label));
}
export function getSystemVariableCategory(label) {
    var _RESOLVABLE_SYSTEM_VARIABLES_find;
    const normalized = normalizeVariableLabel(label);
    return (_RESOLVABLE_SYSTEM_VARIABLES_find = RESOLVABLE_SYSTEM_VARIABLES.find((entry)=>normalizeVariableLabel(entry.label) === normalized)) === null || _RESOLVABLE_SYSTEM_VARIABLES_find === void 0 ? void 0 : _RESOLVABLE_SYSTEM_VARIABLES_find.category;
}
export function extractVariableLabels(text) {
    const seen = new Set();
    const labels = [];
    extractLabelsFromText(text, seen, labels);
    return labels;
}
function extractLabelsFromText(text, seen, labels) {
    for (const match of text.matchAll(makeVariablePattern())){
        const label = match[1].trim();
        const normalized = normalizeVariableLabel(label);
        if (label.length > 0 && label.length <= MAX_VARIABLE_LABEL_LENGTH && !seen.has(normalized)) {
            seen.add(normalized);
            labels.push(label);
        }
    }
}
function parseDeltaInput(richText) {
    if (richText == null || richText === '') return null;
    if (typeof richText === 'string') {
        if (!richText.trim()) return null;
        try {
            const parsed = JSON.parse(richText);
            if (typeof parsed !== 'object' || parsed === null || Array.isArray(parsed)) {
                return {
                    kind: 'non-delta-object'
                };
            }
            return parseDeltaInput(parsed);
        } catch (unused) {
            return null;
        }
    }
    if (typeof richText !== 'object' || richText === null || Array.isArray(richText)) return null;
    const obj = richText;
    if (obj.type === 'quill-delta' && obj.value) {
        const inner = obj.value;
        if (Array.isArray(inner.ops)) {
            return {
                kind: 'delta',
                delta: inner,
                wrapper: obj
            };
        }
    }
    if (Array.isArray(obj.ops)) {
        return {
            kind: 'delta',
            delta: obj,
            wrapper: null
        };
    }
    return {
        kind: 'non-delta-object'
    };
}
function toDelta(richText) {
    const result = parseDeltaInput(richText);
    return (result === null || result === void 0 ? void 0 : result.kind) === 'delta' ? result.delta : null;
}
export function extractVariableLabelsFromDelta(richText) {
    const delta = toDelta(richText);
    if (!(delta === null || delta === void 0 ? void 0 : delta.ops)) {
        return [];
    }
    const seen = new Set();
    const labels = [];
    for (const op of delta.ops){
        if (typeof op.insert === 'string') {
            extractLabelsFromText(op.insert, seen, labels);
        } else if (op.insert && typeof op.insert === 'object' && 'template-variable' in op.insert) {
            const templateVar = op.insert['template-variable'];
            if (templateVar === null || templateVar === void 0 ? void 0 : templateVar.label) {
                const label = templateVar.label.trim();
                if (!label) continue;
                const normalized = normalizeVariableLabel(label);
                if (!seen.has(normalized)) {
                    seen.add(normalized);
                    labels.push(label);
                }
            }
        }
    }
    return labels;
}
function formatDate(date) {
    return date.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
}
function formatMonthName(date) {
    return date.toLocaleDateString('en-US', {
        month: 'long'
    });
}
const ALWAYS_AVAILABLE_RESOLVERS = new Map([
    [
        normalizeVariableLabel("Today's date"),
        formatDate
    ],
    [
        normalizeVariableLabel('Current month'),
        formatMonthName
    ],
    [
        normalizeVariableLabel('Current year'),
        (date)=>String(date.getFullYear())
    ]
]);
export function resolveAlwaysAvailableVariable(label, date) {
    const resolver = ALWAYS_AVAILABLE_RESOLVERS.get(normalizeVariableLabel(label));
    if (!resolver) return undefined;
    return resolver(date !== null && date !== void 0 ? date : new Date());
}
export function resolveSystemVariable(label, context) {
    const normalized = normalizeVariableLabel(label);
    switch(normalized){
        case 'company name':
            return context.clientCompanyName;
        case 'business name':
            return context.vendorBusinessName;
        case 'first name':
            return context.clientFirstName;
        case 'last name':
            return context.clientLastName;
        case 'full name':
            if (context.clientFirstName && context.clientLastName) {
                return "".concat(context.clientFirstName, " ").concat(context.clientLastName);
            }
            return context.clientFirstName || context.clientLastName || undefined;
        case 'email':
            return context.clientEmail;
        case 'agreement name':
            return context.agreementName;
        case 'effective date':
            if (context.effectiveDate === null) return 'the date of acceptance';
            return context.effectiveDate ? formatDate(context.effectiveDate) : undefined;
        case "today's date":
            return formatDate(context.currentDate);
        case 'current month':
            return formatMonthName(context.currentDate);
        case 'current year':
            return String(context.currentDate.getFullYear());
        default:
            return undefined;
    }
}
export function buildSystemVariableResolution(context) {
    const result = {};
    for (const entry of RESOLVABLE_SYSTEM_VARIABLES){
        const key = normalizeVariableLabel(entry.label);
        result[key] = resolveSystemVariable(entry.label, context) || undefined;
    }
    return result;
}
export function resolveVariablesInText(text, resolvedValues) {
    return text.replace(makeVariablePattern(), (fullMatch, label)=>{
        var _resolvedValues_normalizeVariableLabel;
        const trimmed = label.trim();
        return (_resolvedValues_normalizeVariableLabel = resolvedValues[normalizeVariableLabel(trimmed)]) !== null && _resolvedValues_normalizeVariableLabel !== void 0 ? _resolvedValues_normalizeVariableLabel : fullMatch;
    });
}
function resolveDeltaOps(delta, resolvedValues) {
    var _delta_ops;
    const resolvedOps = ((_delta_ops = delta.ops) !== null && _delta_ops !== void 0 ? _delta_ops : []).flatMap((op)=>{
        if (typeof op.insert === 'string') {
            if (!VARIABLE_PRESENCE_PATTERN.test(op.insert)) return op;
            return _object_spread_props(_object_spread({}, op), {
                insert: resolveVariablesInText(op.insert, resolvedValues)
            });
        }
        if (op.insert && typeof op.insert === 'object' && 'template-variable' in op.insert) {
            const templateVar = op.insert['template-variable'];
            if (templateVar === null || templateVar === void 0 ? void 0 : templateVar.label) {
                const label = templateVar.label.trim();
                if (!label) return [];
                const resolved = resolvedValues[normalizeVariableLabel(label)];
                if (resolved !== undefined) {
                    return _object_spread_props(_object_spread({}, op), {
                        insert: resolved
                    });
                }
                return _object_spread_props(_object_spread({}, op), {
                    insert: "{{".concat(label, "}}")
                });
            }
            return [];
        }
        return op;
    });
    return _object_spread_props(_object_spread({}, delta), {
        ops: resolvedOps
    });
}
export function resolveVariablesInDelta(richText, resolvedValues) {
    const parseResult = parseDeltaInput(richText);
    if (parseResult === null) {
        if (typeof richText === 'string') return resolveVariablesInText(richText, resolvedValues);
        return richText;
    }
    if (parseResult.kind === 'non-delta-object') return richText;
    const { delta, wrapper } = parseResult;
    const resolvedDelta = resolveDeltaOps(delta, resolvedValues);
    if (typeof richText === 'string') {
        if (wrapper) {
            return JSON.stringify(_object_spread_props(_object_spread({}, wrapper), {
                value: resolvedDelta
            }));
        }
        return JSON.stringify(resolvedDelta);
    }
    if (wrapper) {
        return _object_spread_props(_object_spread({}, wrapper), {
            value: resolvedDelta
        });
    }
    return resolvedDelta;
}
// resolveService resolves the same fields that templateVarTextFields and templateVarRichTextFields
// scan for variable labels: s.name, s.description, s.terms, s.bundle.services[i].name,
// s.bundle.services[i].description, s.bundle.services[i].terms. Keep these in sync when adding new resolved fields.
export function resolveService(s, resolved) {
    return _object_spread(_object_spread_props(_object_spread({}, s), {
        name: resolveVariablesInText(s.name, resolved),
        description: resolveVariablesInDelta(s.description, resolved),
        terms: resolveVariablesInDelta(s.terms, resolved)
    }), s.bundle && {
        bundle: _object_spread_props(_object_spread({}, s.bundle), {
            services: s.bundle.services.map((includedService)=>_object_spread_props(_object_spread({}, includedService), {
                    name: resolveVariablesInText(includedService.name, resolved),
                    description: resolveVariablesInDelta(includedService.description, resolved),
                    terms: resolveVariablesInDelta(includedService.terms, resolved)
                }))
        })
    });
}
export function inlineTemplateVariableBlots(richText) {
    var _parsed_delta_ops;
    const parsed = parseDeltaInput(richText);
    if (!parsed || parsed.kind !== 'delta') return richText;
    const newOps = ((_parsed_delta_ops = parsed.delta.ops) !== null && _parsed_delta_ops !== void 0 ? _parsed_delta_ops : []).map((op)=>{
        if (op.insert && typeof op.insert === 'object' && 'template-variable' in op.insert) {
            const templateVar = op.insert['template-variable'];
            if (templateVar === null || templateVar === void 0 ? void 0 : templateVar.label) {
                return _object_spread_props(_object_spread({}, op), {
                    insert: "{{".concat(templateVar.label, "}}")
                });
            }
            return _object_spread_props(_object_spread({}, op), {
                insert: ''
            });
        }
        return op;
    });
    const newDelta = _object_spread_props(_object_spread({}, parsed.delta), {
        ops: newOps
    });
    if (typeof richText === 'string') {
        return parsed.wrapper ? JSON.stringify(_object_spread_props(_object_spread({}, parsed.wrapper), {
            value: newDelta
        })) : JSON.stringify(newDelta);
    }
    if (parsed.wrapper) {
        return _object_spread_props(_object_spread({}, parsed.wrapper), {
            value: newDelta
        });
    }
    return newDelta;
}
export function filterVariablesBySearch(variables, search) {
    const trimmed = search.trim();
    if (!trimmed) {
        return variables;
    }
    const normalizedSearch = normalizeVariableLabel(trimmed);
    return variables.filter((variable)=>normalizeVariableLabel(variable.label).includes(normalizedSearch));
}
